import { NetworkBasePopUp } from './popUps/NetworkBasePopUp';
import { LitElement } from 'lit';
import { BasePopUpData } from './types';
import { IocScanPopUp } from './popUps/ioc/IocScanPopUp';
import { NetworkFeedbackFormWindow } from './popUps/networkFeedbackForm/NetworkFeedbackFormWindow';
import { InstallAgentPopUp } from './popUps/installAgent/InstallAgentPopUp';
import { ReconfigureAgentPopUp } from './popUps/reconfigureAgent/ReconfigureAgentPopUp';
import { MalwareScanPopUp } from './popUps/malware/MalwareScanPopUp';
import { ExchangeScanTaskPopUp } from './popUps/exchangeScanTask/ExchangeScanTaskPopUp';
import { RepairAgentPopUp } from './popUps/repairAgent/RepairAgentPopUp';
import { IsolateEndpointPopUp } from './popUps/isolateEndpoint/IsolateEndpointPopUp';
import { RemoveFromIsolationPopUp } from './popUps/removeFromIsolation/RemoveFromIsolationPopUp';
import { RestartTaskPopUp } from './popUps/restartTask/RestartTaskPopUp';
import { UninstallAgentPopUp } from './popUps/uninstallAgent/UninstallAgentPopUp';
import { InstallPatchesPopUp } from './popUps/installPatches/InstallPatchesPopUp';
import { MarkGoldenImagePopUp } from './popUps/goldenImage/mark/MarkGoldenImagePopUp';
import { UnmarkGoldenImagePopUp } from './popUps/goldenImage/unMark/UnmarkGoldenImagePopUp';
import { TagsManagementPopUp } from './popUps/tagsManagement/TagsManagementPopUp';
import { UpdateAgentPopUp } from './popUps/updateAgent/UpdateAgentPopUp';
import { DeleteEntityPopUp } from './popUps/delete/DeleteEntityPopUp';
import { PatchScanPopUp } from './popUps/patchScan/PatchScanPopUp';
import { ResumeIntegrityMonitoringPopUp } from './popUps/resumeIntegrityMonitoring/ResumeIntegrityMonitoringPopUp';
import { SuspendIntegrityMonitoringPopUp } from './popUps/suspendIntegrityMonitoring/SuspendIntegrityMonitoringPopUp';
import { AssignPolicyPopUp } from './popUps/assignPolicy/AssignPolicyPopUp';
import { ActionErrorPopUp } from './popUps/actionError/ActionErrorPopUp';
import { RunNetworkDiscoveryPopUp } from './popUps/runNetworkDiscovery/RunNetworkDiscoveryPopUp';
import { RiskScanPopUp } from './popUps/riskScan/RiskScanPopUp';
import { UpdateSecurityServerPopUp } from './popUps/updateSecurityServer/UpdateSecurityServerPopUp';
import { RemoteShellPopUp } from './popUps/remoteShell/RemoteShellPopUp';
import { MoveToPopUp } from './popUps/moveTo/MoveToPopUp';
import { AssignSecurityServersPopUp } from './popUps/assignSecurityServers/AssignSecurityServersPopUp';
import { RecoveryManagerPopUp } from './popUps/recoveryManager/RecoveryManagerPopUp';
import { SubmitToSandboxPopUp } from './popUps/submitToSandbox/SubmitToSandboxPopUp';
import { SuspendProtectionPopUp } from './popUps/suspendProtection/SuspendProtectionPopUp';
import { ResumeProtectionPopUp } from './popUps/resumeProtection/ResumeProtectionPopUp';
import { SetADPopUp } from './popUps/setADIntegrator/SetADPopUp';
import { RemoveADIntegratorPopUp } from './popUps/removeADIntegrator/RemoveADIntegratorPopUp';
import { RemoveADIntegrationPopUp } from './popUps/removeADIntegration/RemoveADIntegrationPopUp';
import {SetVmwareIntegratorPopUp} from "./popUps/setVmwareIntegrator/SetVmwareIntegratorPopUp";
import { UnsetVmwareIntegratorPopUp } from './popUps/unsetVmwareIntegrator/UnsetVmwareIntegratorPopUp';
import { SyncWithEC2PopUp } from './popUps/syncWithEC2/SyncWithEC2PopUp';

export enum NetworkPopUpType {
  NETWORK_FEEDBACK_FORM = -1,
  ACTION_ERROR_POP_UP = 0,
  ASSIGN_POLICY = 101,
  ASSIGN_SECURITY_SERVERS = 102,
  TAGS_MANAGEMENT = 103,
  INSTALL_AGENT = 104,
  INSTALL_PATCHES = 105,
  ISOLATE_ENDPOINT = 106,
  RECONFIGURE_AGENT = 108,
  REMOVE_FROM_ISOLATION = 110,
  REPAIR_AGENT = 111,
  RESTART_TASK = 112,
  RESUME_INTEGRITY_MONITORING = 113,
  UNINSTALL_AGENT = 116,
  UPDATE_AGENT = 117,
  EXCHANGE_SCAN_TASK = 201,
  MALWARE_SCAN = 202,
  RUN_NETWORK_DISCOVERY = 203,
  REMOTE_SHELL = 204,
  RISK_SCAN = 205,
  IOC_SCAN = 206,
  SET_AD_INTEGRATOR = 301,
  REMOVE_AD_INTEGRATOR = 302,
  REMOVE_AD_INTEGRATION = 303,
  SYNC_WITH_EC2 = 304,
  MARK_GOLDEN_IMAGE = 305,
  UNMARK_GOLDEN_IMAGE = 306,
  DELETE_ENTITY = 905,
  PATCH_SCAN = 207,
  SUSPEND_INTEGRITY_MONITORING = 114,
  UPDATE_SECURITY_SERVER = 118,
  MOVE_TO = 121,
  RECOVERY_MANAGER = 902,
  SUBMIT_TO_SANDBOX = 208,
  SUSPEND_PROTECTION = 209,
  RESUME_PROTECTION = 210,
  ASSIGN_VCENTER_INTEGRATOR = 211,
  UNASSIGN_VCENTER_INTEGRATOR = 212,
}

type PopUpClass = new (data?: BasePopUpData<any>) => NetworkBasePopUp<any>;

export class NetworkPopUpFactory {
  private static readonly popUps: Record<NetworkPopUpType, PopUpClass> = {
    [NetworkPopUpType.IOC_SCAN]: IocScanPopUp,
    [NetworkPopUpType.NETWORK_FEEDBACK_FORM]: NetworkFeedbackFormWindow,
    [NetworkPopUpType.ACTION_ERROR_POP_UP]: ActionErrorPopUp,
    [NetworkPopUpType.INSTALL_AGENT]: InstallAgentPopUp,
    [NetworkPopUpType.RECONFIGURE_AGENT]: ReconfigureAgentPopUp,
    [NetworkPopUpType.MALWARE_SCAN]: MalwareScanPopUp,
    [NetworkPopUpType.UPDATE_AGENT]: UpdateAgentPopUp,
    [NetworkPopUpType.EXCHANGE_SCAN_TASK]: ExchangeScanTaskPopUp,
    [NetworkPopUpType.REPAIR_AGENT]: RepairAgentPopUp,
    [NetworkPopUpType.ISOLATE_ENDPOINT]: IsolateEndpointPopUp,
    [NetworkPopUpType.REMOVE_FROM_ISOLATION]: RemoveFromIsolationPopUp,
    [NetworkPopUpType.RESTART_TASK]: RestartTaskPopUp,
    [NetworkPopUpType.UNINSTALL_AGENT]: UninstallAgentPopUp,
    [NetworkPopUpType.INSTALL_PATCHES]: InstallPatchesPopUp,
    [NetworkPopUpType.MARK_GOLDEN_IMAGE]: MarkGoldenImagePopUp,
    [NetworkPopUpType.UNMARK_GOLDEN_IMAGE]: UnmarkGoldenImagePopUp,
    [NetworkPopUpType.TAGS_MANAGEMENT]: TagsManagementPopUp,
    [NetworkPopUpType.DELETE_ENTITY]: DeleteEntityPopUp,
    [NetworkPopUpType.PATCH_SCAN]: PatchScanPopUp,
    [NetworkPopUpType.RESUME_INTEGRITY_MONITORING]: ResumeIntegrityMonitoringPopUp,
    [NetworkPopUpType.SUSPEND_INTEGRITY_MONITORING]: SuspendIntegrityMonitoringPopUp,
    [NetworkPopUpType.ASSIGN_POLICY]: AssignPolicyPopUp,
    [NetworkPopUpType.RUN_NETWORK_DISCOVERY]: RunNetworkDiscoveryPopUp,
    [NetworkPopUpType.RISK_SCAN]: RiskScanPopUp,
    [NetworkPopUpType.UPDATE_SECURITY_SERVER]: UpdateSecurityServerPopUp,
    [NetworkPopUpType.REMOTE_SHELL]: RemoteShellPopUp,
    [NetworkPopUpType.MOVE_TO]: MoveToPopUp,
    [NetworkPopUpType.ASSIGN_SECURITY_SERVERS]: AssignSecurityServersPopUp,
    [NetworkPopUpType.RECOVERY_MANAGER]: RecoveryManagerPopUp,
    [NetworkPopUpType.SUBMIT_TO_SANDBOX]: SubmitToSandboxPopUp,
    [NetworkPopUpType.SUSPEND_PROTECTION]: SuspendProtectionPopUp,
    [NetworkPopUpType.RESUME_PROTECTION]: ResumeProtectionPopUp,
    [NetworkPopUpType.SET_AD_INTEGRATOR]: SetADPopUp,
    [NetworkPopUpType.REMOVE_AD_INTEGRATOR]: RemoveADIntegratorPopUp,
    [NetworkPopUpType.REMOVE_AD_INTEGRATION]: RemoveADIntegrationPopUp,
    [NetworkPopUpType.ASSIGN_VCENTER_INTEGRATOR]: SetVmwareIntegratorPopUp,
    [NetworkPopUpType.UNASSIGN_VCENTER_INTEGRATOR]: UnsetVmwareIntegratorPopUp,
    [NetworkPopUpType.SYNC_WITH_EC2]: SyncWithEC2PopUp,
  };

  public static create<PopUpSpecifics>(type: NetworkPopUpType, data?: BasePopUpData<PopUpSpecifics>): NetworkBasePopUp<any> {
    const popUp = this.popUps[type];

    if (!popUp) {
      throw new Error('Could not create popUp of type: ' + type);
    }

    return new popUp(data);
  }

  public static getContent<PopUpSpecifics>(type: NetworkPopUpType, data?: BasePopUpData<PopUpSpecifics>, dependencies = null): LitElement {
    const popUp = NetworkPopUpFactory.create(type, data);
    popUp.dependencies = dependencies;
    return popUp.getContent();
  }
}
